import StyleSheetPropType from "../../modules/StyleSheetPropType";
import TextStylePropTypes from "./TextStylePropTypes";
import { any, array, bool, func, number, oneOf, oneOfType, string } from 'prop-types';
var TextPropTypes = {
  accessibilityComponentType: string,
  accessibilityLabel: string,
  accessibilityLiveRegion: oneOf(['assertive', 'none', 'polite']),
  accessibilityRole: oneOf(['button', 'header', 'heading', 'label', 'link', 'listitem', 'none', 'text']),
  accessibilityTraits: oneOfType([array, string]),
  accessible: bool,
  children: any,
  importantForAccessibility: oneOf(['auto', 'no', 'no-hide-descendants', 'yes']),
  maxFontSizeMultiplier: number,
  nativeID: string,
  numberOfLines: number,
  onBlur: func,
  onFocus: func,
  onLayout: func,
  onPress: func,
  selectable: bool,
  style: StyleSheetPropType(TextStylePropTypes),
  testID: string,
  onContextMenu: func,
  itemID: string,
  itemRef: string,
  itemProp: string,
  itemScope: string,
  itemType: string
};
export default TextPropTypes;